import { normalizeSeverity, CANONICAL_SEVERITIES } from './severity'

/**
 * severityDistribution — per-severity counts across a scanned entity list,
 * for the run-level distribution bar. Never-probed entities (and those with
 * no recognizable severity) form their own grey segment: a run that skipped
 * 10% of its scope must not read as 100% healthy (audit F6 principle).
 *
 * @param {Array} entities - entity summaries (must cover the scanned scope)
 * @returns {{ critical: number, severe: number, moderate: number, watch: number,
 *   mild: number, healthy: number, unprobed: number, total: number }}
 */
export const severityDistribution = (entities = []) => {
    // Seeded from CANONICAL_SEVERITIES rather than a hand-written literal: a
    // seventh tier would otherwise land as NaN here and nowhere in the bar.
    const counts = { unprobed: 0, total: 0 }
    for (const key of CANONICAL_SEVERITIES) counts[key] = 0
    for (const entity of entities) {
        counts.total += 1
        if (entity?.unprobed === true) {
            counts.unprobed += 1
            continue
        }
        const key = normalizeSeverity(entity?.severity)
        if (key === 'unknown') {
            counts.unprobed += 1
        } else {
            counts[key] += 1
        }
    }
    return counts
}
